import { useFirebase } from 'components/Firebase/index.js';
import { useState, useEffect } from 'react';

const useQuota = ({ orgId, quotaType }) => {
  const [quota, setQuota] = useState();
  const firebase = useFirebase();

  useEffect(() => {
    if (!orgId) return;
    const getQuota = async (orgId) => {
      const agent = await firebase.getAgent();
      const { body: { quota } } = await agent.get(`/o/${orgId}/quotas/${quotaType}`);
      setQuota(quota === null ? Infinity : quota);
    };

    getQuota(orgId);
  }, [firebase, orgId, quotaType]);

  return quota;
};

export default useQuota;
